<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let hours: number = 0;
    export let minutes: number = 0;
    export let seconds: number = 0;
    export let disabled: boolean = false;

    errors[name] = [];

    const validate = () => {
        const errs: string[] = [];
        if (isNaN(hours)   || hours   < 0 || hours   > 23) errs.push('Hours must be 0–23');
        if (isNaN(minutes) || minutes < 0 || minutes > 59) errs.push('Minutes must be 0–59');
        if (isNaN(seconds) || seconds < 0 || seconds > 59) errs.push('Seconds must be 0–59');
        errors[name] = errs;
    };
    validate();

    const parseField = (e: Event) => {
        const raw = (e.currentTarget as HTMLInputElement).value;
        return raw === '' ? NaN : parseInt(raw, 10);
    };

    const handleH = (e: Event) => { hours   = parseField(e); validate(); };
    const handleM = (e: Event) => { minutes = parseField(e); validate(); };
    const handleS = (e: Event) => { seconds = parseField(e); validate(); };

    onDestroy(() => { errors[name] = []; });
</script>

<div class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <div class="duration-row">
        <div class="duration-field">
            <input type="number" min="0" max="23" value={hours}   {disabled} on:input={handleH} class="input-mono" class:error={errors[name].length > 0} />
            <span class="duration-sep">h</span>
        </div>
        <div class="duration-field">
            <input type="number" min="0" max="59" value={minutes} {disabled} on:input={handleM} class="input-mono" class:error={errors[name].length > 0} />
            <span class="duration-sep">m</span>
        </div>
        <div class="duration-field">
            <input type="number" min="0" max="59" value={seconds} {disabled} on:input={handleS} class="input-mono" class:error={errors[name].length > 0} />
            <span class="duration-sep">s</span>
        </div>
    </div>
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</div>

<style lang="scss">
    .duration-row {
        display: flex;
        gap: 0.75em;
        align-items: center;
    }

    .duration-field {
        display: flex;
        align-items: center;
        gap: 0.4em;

        input {
            width: 3.5em;
            text-align: center;
            margin: 0;
            padding: 0.85em 0.5em;
            appearance: textfield;
            -moz-appearance: textfield;
            border: 1px solid $color-border;
            border-radius: $border-radius-small;
            background: transparent;
            color: $color-text;
            font-family: inherit;
            font-size: $font-size;
            transition: all 0.2s ease;

            &:hover:not(:disabled) { border-color: $color-text; background-color: rgba(128, 128, 128, 0.03); }
            &:focus:not(:disabled) { outline: none; border: 2px solid $color-primary; padding: calc(0.85em - 1px) calc(0.5em - 1px); }

            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }
    }

    .duration-sep {
        font-size: 0.85em;
        font-weight: 500;
        color: $color-text-secondary;
    }
</style>
